<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('detailEmplacement.info') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('adresseEmplacement.natureSol')">
          <b-input type="text"
                   v-model="emplacementTechniqueInformation.natureSol">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('adresseEmplacement.codeBarre')">
          <b-input v-model="emplacementTechniqueInformation.codeBarre"
                   type="text">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('adresseEmplacement.degreDeniveleTerrain')">
          <input-currency v-model="emplacementTechniqueInformation.degreDeniveleTerrain"
                          isNumber="true">
          </input-currency>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('adresseEmplacement.accesSiteSurRdv')">
          <b-checkbox v-model="emplacementTechniqueInformation.accesSiteSurRdv">
          </b-checkbox>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field
          :label="$t('adresseEmplacement.acces')" >
          <b-input v-model="emplacementTechniqueInformation.acces"
                   type="text">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field
          :label="$t('adresseEmplacement.groupeDhabitation')">
          <b-input v-model="emplacementTechniqueInformation.groupeDhabitation"
                   type="text">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field
          :label="$t('adresseEmplacement.numUg')">
          <b-input v-model="emplacementTechniqueInformation.numUG"
                   type="text">
          </b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field
          :label="$t('adresseEmplacement.quartier')">
          <b-input v-model="emplacementTechniqueInformation.quartier"
                   type="text">
          </b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import inputCurrency from '@/components/general/inputCurrency';

export default {
  name: 'm_infoTechnique',
  props: {
    emplacementTechniqueInformation: {
      type: Object,
      required: true,
    },
  },
  components: {
    inputCurrency,
  },
};
</script>
